var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"pok-logo",attrs:{"src":"/logo.png","alt":"Palace of Kebap"}})
}
var staticRenderFns = []

export { render, staticRenderFns }